<div (mousedown)="onContainerClick($event, contentHostContainer)" class="tw-flex tw-flex-col tw-h-full tw-w-full">

  <wizard-header
    #wizardHeader
    [breadcrumbs]="breadcrumbs"
    (onClose)="close()"
  ></wizard-header>

  <div #contentHostContainer class="tw-flex-1 tw-overflow-auto tw-flex tw-flex-col" cdkScrollable data-wizard-scroll>
    <ng-container #contentHost></ng-container>
  </div>

  <app-unsaved-changes-modal
    [id]="UNSAVED_MODAL_ID"
    (saveChanges)="saveChangesAndLeave()"
    (cancel)="cancelAndLeave()"
    (dismissed)="closeModalOnly()"
  ></app-unsaved-changes-modal>
</div>
